import axios from 'axios';

export const storeReplaceApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/store-replace`,
    headers: {
        'Content-Type': 'application/json'
    }
})